// extracted by mini-css-extract-plugin
module.exports = {"addRoundedButtonStyle":"addRoundedButton_addRoundedButtonStyle__2gR-J"};